// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qo_a bht_sw bht_kx bht_ky","PostDetailRight__brandDaysPosts":"qo_b bht_sw bht_kx bht_ky"};